/**
 * Auto-generated Zod schema for SecurityAdvisoryPerformedEvent
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { SecurityAdvisoryPerformedEvent as SecurityAdvisoryPerformedEventOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

export const SecurityAdvisoryPerformedEventSchema = z.object({
  action: z.literal('performed'),
  security_advisory: z.object({
    cvss: z.object({
      vector_string: z.string().nullable(),
      score: z.number(),
    }),
    cwes: z.array(
      z.object({
        cwe_id: z.string(),
        name: z.string(),
      }),
    ),
    ghsa_id: z.string(),
    cve_id: z.string().nullable(),
    summary: z.string(),
    description: z.string(),
    severity: z.string(),
    identifiers: z.array(
      z.object({
        value: z.string(),
        type: z.string(),
      }),
    ),
    references: z.array(
      z.object({
        url: z.string(),
      }),
    ),
    published_at: z.string(),
    updated_at: z.string(),
    withdrawn_at: z.string().nullable(),
    vulnerabilities: z.array(
      z.object({
        package: z.object({
          ecosystem: z.string(),
          name: z.string(),
        }),
        severity: z.string(),
        vulnerable_version_range: z.string(),
        first_patched_version: z
          .object({
            identifier: z.string(),
          })
          .nullable(),
      }),
    ),
  }),
}) satisfies z.ZodType<SecurityAdvisoryPerformedEventOctokit>;

export type SecurityAdvisoryPerformedEvent = SecurityAdvisoryPerformedEventOctokit;

export function isSecurityAdvisoryPerformedEvent(
  value: unknown,
): value is SecurityAdvisoryPerformedEvent {
  return SecurityAdvisoryPerformedEventSchema.safeParse(value).success;
}
